import type { Page, PageableInfoNew, Vod } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { genPagesLogicNew } from '~/shared/effector'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const resetOnlyFavoritesVodsRow = createEvent()
export const $onlyFavoritesVodsRow = createStore<Page<Vod> | null>(null)
  .on(api.vods.getOnlyFavoritesVodsRowFx.doneData, (_, page) => page)
  .on(ssePurchasesModel.$vod, (page, adjust) => {
    if (page == null) return page
    return {
      ...page,
      content: page.content.map((item) => adjust(item)),
    }
  })
  .reset(resetOnlyFavoritesVodsRow)

export const $onlyFavoritesVodsRowFormatted = combine(
  $onlyFavoritesVodsRow,
  i18n.$t,
  (onlyFavoritesVodsRow) => ({
    ...onlyFavoritesVodsRow,
    content: onlyFavoritesVodsRow?.content.map((item) =>
      extendMediaItemByLabelPrice(item)
    ),
  })
)

export const resetOnlyFavoritesVodsGrid = createEvent()
export const $onlyFavoritesVodsGrid = createStore<Page<Vod> | null>(null)
  .on(api.vods.getOnlyFavoritesVodsGridFx.doneData, (state, page) => {
    const currentVods = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentVods,
    }
  })
  .on(ssePurchasesModel.$vod, (page, adjust) => {
    if (page == null) return page
    return {
      ...page,
      content: page.content.map((item) => adjust(item)),
    }
  })
  .reset(resetOnlyFavoritesVodsGrid)

export const $onlyFavoritesVodsGridFormatted = combine(
  $onlyFavoritesVodsGrid,
  i18n.$t,
  (onlyFavoritesVodsGrid) => {
    const formattedPageContent = onlyFavoritesVodsGrid?.content.map((item) =>
      extendMediaItemByLabelPrice(item)
    )

    return {
      ...onlyFavoritesVodsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMoreOnlyFavoritesVodsGrid = genPagesLogicNew(
  $onlyFavoritesVodsGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.vods.getOnlyFavoritesVodsGridFx
)
